module.exports = "https://www.gc-pro.gnp.com.mx/b1ce542c1598f1ffabcdb7d96f5ae0e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/iconautos.svg
// module id = 8136
// module chunks = 0